// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3oISQ","label":"Labeled_label__2qyrR","divider":"Labeled_divider__18rmO"};